/*eslint-disable*/
import OPERATORS from "../../constants/operators";

// helpers
import { areObjectsEqual } from "../../utils/general"

const addNameToOperations = (user, userDTO) => {
  const { firstName, lastName } = user;
  const nameOperation = {
    op: "replace",
    path: "name",
    value: {
      givenName: firstName,
      familyName: lastName,
    },
  };
  userDTO.operations.push(nameOperation);
};

const addEmailToOperations = (user, userDTO, canCreateJNJUser, existingUser) => {
  const { email } = user;
  if (existingUser?.emails?.[0].value.toLowerCase() === email.toLowerCase()) {
    return;
  }
  if (!canCreateJNJUser && email.toLowerCase().endsWith('its.jnj.com')) {
    return;
  }
  const emailOperation = {
    op: "replace",
    path: "emails",
    value: [
      {
        type: "work",
        value: email,
        primary: true,
      },
    ],
  };
  userDTO.operations.push(emailOperation);
};

const addPhoneNumberToOperations = (user, userDTO) => {
  const { phoneNumber='' } = user;
    const phoneNumberOperation = {
      op: "replace",
      path: "phoneNumbers",
      value: [
        {
          type: "mobile",
          value: phoneNumber,
        },
      ],
    };
    userDTO.operations.push(phoneNumberOperation);
};

const addAddressToOperations = (user, userDTO) => {
  const { country='' } = user;
    const countryOperation = {
        "op": "replace",
        "path": "addresses",
        "value": [
          {
            "country": country
          }
        ]
    };  
    userDTO.operations.push(countryOperation);
};

const addLocaleToOperations = (user, userDTO) => {
  const {  locale='' } = user;
    const localeOperation = {
      op: "replace",
      path: "locale",
      value: locale,
    };
    userDTO.operations.push(localeOperation);
};

const addPreferredLanguageToOperations = (user, userDTO) => {
  const {  preferredLanguage='' } = user;
    const preferredLanguageOperation = {
      op: "replace",
      path: "preferredLanguage",
      value: preferredLanguage,
    };
    userDTO.operations.push(preferredLanguageOperation);
};

const getAddedGroupIds = (initialUserGroupIds, userGroupIds) => {
  const addedGroupIds = userGroupIds.filter(
    (value) => !initialUserGroupIds.includes(value)
  ) || [];
  return addedGroupIds
};


const getDeletedGroupIds = (initialUserGroupIds, userGroupIds) => {
    const deletedGroupIds = initialUserGroupIds.filter(
      (value) => !userGroupIds.includes(value)
    ) || [];
    return deletedGroupIds
  };

const addGroupsToOperations = (initialUser, user, userDTO) => {
  const initialUserGroupIds = initialUser?.groups?.map(group => group?.value);
  const userGroupIds = user?.groups?.map(group => group?.value);
  const addedGroupIds = getAddedGroupIds(initialUserGroupIds, userGroupIds);
  const deletedGroupIds = getDeletedGroupIds(initialUserGroupIds, userGroupIds);
  if (addedGroupIds?.length > 0) {
    const addedGroupsOperation = {
      op: "add",
      path: "group",
      value: addedGroupIds,
    };
    userDTO.operations.push(addedGroupsOperation);
  }
  if (deletedGroupIds?.length > 0) {
    const deletedGroupsOperation = {
      op: "remove",
      path: "group",
      value: deletedGroupIds,
    };
    userDTO.operations.push(deletedGroupsOperation);
  }
  userDTO.groupsOverride = true;
};

export const makeEditUserDTO = (canCreateJNJUser, userObj = {}, user = {}) => {
  const initialUser = getInitialUser(userObj);
  const userDTO = {
    schemas: '["urn:ietf:params:scim:schemas:core:2.0:User"]',
    operations: [],
  };
  addNameToOperations(user, userDTO);
  addEmailToOperations(user, userDTO, canCreateJNJUser, userObj);
  addPhoneNumberToOperations(user, userDTO);
  addAddressToOperations(user, userDTO);
  addLocaleToOperations(user, userDTO);
  addPreferredLanguageToOperations(user, userDTO);
  addGroupsToOperations(initialUser, user, userDTO);
  return userDTO;
};

const getGroupIds = (userObj) => userObj.groups?.map((group) => group?.value);

export const getInitialUser = (userObj = {}) => {
  
  const firstName = userObj?.name?.givenName;
  const lastName = userObj?.name?.familyName;
  const email = userObj?.emails?.[0].value;
  const phoneNumber = userObj?.phoneNumbers?.[0]?.value || '';
  const groups = userObj?.groups;
  const country = userObj?.addresses?.[0]?.country;
  const locale = userObj?.locale;
  const preferredLanguage = userObj?.preferredLanguage
  return {
    firstName,
    lastName,
    email,
    phoneNumber,
    groups,
    country,
    locale,
    preferredLanguage
  };
};

export const areFormValuesChanged = (userObj={}, user={}) => {
  const initialUser = getInitialUser(userObj);
  if(areObjectsEqual(initialUser, user)) {
    return false
  }
  return true
}

export const getSelectedGroupsCount = (userObj) => (selectedGroups=[]) => {
  const initialUser = getInitialUser(userObj);
  const initialUserGroupIds = initialUser?.groups?.map(group => group?.value);
  const userGroupIds = selectedGroups?.map(group => group?.value);
  const addedGroupIds = getAddedGroupIds(initialUserGroupIds, userGroupIds);
  const deletedGroupIds = getDeletedGroupIds(initialUserGroupIds, userGroupIds);
  return addedGroupIds.length + deletedGroupIds.length;
}
